import * as React from "react";
import { render } from "react-dom";

// css
import "../css/open-iconic-bootstrap.min.css";
import "../css/animate.css";
import "../css/owl.carousel.min.css";
import "../css/owl.theme.default.min.css";
import "../css/magnific-popup.css";
import "../css/aos.css";
import "../css/ionicons.min.css";
import "../css/bootstrap-datepicker.css";
import "../css/jquery.timepicker.css";
import "../css/flaticon.css";
import "../css/icomoon.css";
import "../css/style.css";
import "../css/academicons.min.css";
import "../scss/custom.scss";

import "../js/fontawesome.js";

import App from "./components/app";
import { LangProvider } from "./lang";

// rendering
render(
  <LangProvider>
    <App />
  </LangProvider>,
  document.querySelector("#root")
);
